import {
  useQueryClient,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { TotpUserFactor } from "@okta/okta-sdk-nodejs";

import { API_ENROLL_TOTP_FACTOR_URL } from "constants/apiUrls";

import { QueryKey } from "types/queryKey/queryKey";
import { Provider } from "types/factor/factor";

import useGetApiClient from "./useGetApiClient";

export type EnrollTotpData = {
  provider: Provider;
};

function useEnrollTotpFactor(): UseMutationResult<
  TotpUserFactor,
  unknown,
  EnrollTotpData
> {
  const apiClient = useGetApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      const response = await apiClient(API_ENROLL_TOTP_FACTOR_URL, {
        method: "POST",
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return await response.json();
      }
    },
    onSuccess: () => {
      queryClient.fetchQuery([QueryKey.AllFactors]);
    },
    onError: (error) => {
      console.log("Error!!!!!");
      console.log(error);
    },
  });
}

export default useEnrollTotpFactor;
